import React, { useState } from 'react';
import { Button, InlineNotification, Radio, SelectInput, Text, TextInput } from '@ui';
import { SeriesScope, VisitPriority } from './types';
import { t } from './translate';
function VisitExtraFields({ draft, disabled, seriesFrequencyLabel, showSeries, conflict, onChange }) {
    const [notesOpen, setNotesOpen] = useState(draft.visitNotes !== '');
    const priorityOptions = [
        { value: VisitPriority.NORMAL, label: t('priorities.normal') },
        { value: VisitPriority.HIGH, label: t('priorities.high') }
    ];
    const seriesOptions = [
        { value: SeriesScope.THIS_ONLY, label: t('series.inspection_only') },
        seriesFrequencyLabel
            ? { value: SeriesScope.BY_FREQUENCY, label: t('series.by_frequency', { frequency: seriesFrequencyLabel }) }
            : null,
        { value: SeriesScope.ALL, label: t('series.all_serie') }
    ].filter((option) => option !== null);
    return (React.createElement(React.Fragment, null,
        React.createElement(SelectInput, { id: "visit-priority", label: t('priority'), disabled: disabled, options: priorityOptions, value: draft.priority, onChange: (value) => onChange({ priority: value }) }),
        draft.priority === VisitPriority.HIGH && (React.createElement(TextInput, { id: "visit-priority-note", multiline: true, label: t('priority_note'), disabled: disabled, value: draft.priorityNote, onChange: (event) => onChange({ priorityNote: event.target.value }) })),
        notesOpen ? (React.createElement(TextInput, { id: "visit-notes", multiline: true, label: t('visit_notes'), disabled: disabled, value: draft.visitNotes, onChange: (event) => onChange({ visitNotes: event.target.value }) })) : (React.createElement("div", { className: "visits-section__notes-row" },
            React.createElement(Text, { variant: "body" }, t('visit_notes')),
            React.createElement(Button, { onClick: () => setNotesOpen(true) }, t('add_notes')))),
        conflict && (React.createElement(InlineNotification, { variant: "warning" },
            conflict.message,
            conflict.link && (React.createElement(React.Fragment, null,
                ' ',
                React.createElement("a", { href: conflict.link.href, target: "_blank", rel: "noopener noreferrer" }, conflict.link.text))))),
        showSeries && (React.createElement(Radio, { name: "visit-series-scope", label: t('series.label'), options: seriesOptions, value: draft.updateAll, disabled: disabled, onChange: (updateAll) => onChange({ updateAll }) }))));
}
export default VisitExtraFields;
